import React from 'react';
import { Link } from 'react-router-dom';

import icastImage from '../../../Assets/Linkages/InternationalConferences/ICAST-Introduction.png';
import '../../../Styles/ICASTFeature.css';
import '../../../Styles/ICASTFeature.css';
import './ICASTFeature.css';

const ICASTFeature = () => (
  <section className="international-conference-feature" aria-labelledby="icast-feature-title">
    <div className="international-conference-feature-inner">
      <figure className="international-conference-feature-image">
        <img src={icastImage} alt="International Conference on Applications of Space Science and Technology" loading="lazy" />
      </figure>

      <div className="international-conference-feature-copy">
        <p className="section-eyebrow">PAKISTAN’S PREMIER GLOBAL SPACE FORUM</p>
        <h2 id="icast-feature-title">International Conference on Applications of Space Science and Technology</h2>
        <div className="world-space-week-title-line" aria-hidden="true" />
        <p>
          The International Conference on Applications of Space Science and Technology (ICAST)
          marks a transformative milestone in Pakistan’s journey through space science and
          technology. As the largest space event in the country, ICAST unites the legacies of IST’s
          International Conference on Aerospace Science and Engineering (ICASE) and SUPARCO’s
          International Conference on Space (ICS) into a biennial global forum of unparalleled excellence.
        </p>
        <p>
          Bringing together visionaries, global thought leaders, pioneering researchers, and
          industry trailblazers, ICAST aspires to redefine the future of space science by fostering
          collaboration, presenting transformative research, and exploring interdisciplinary space
          applications with the potential to reshape our collective future.
        </p>
        <Link
          className="outreach-film-trailer-link"
          to="/icast-2025"
          aria-label="Read more about ICAST 2025"
        >
          Read More <span aria-hidden="true">→</span>
        </Link>
      </div>
    </div>
  </section>
);

export default ICASTFeature;
